import styled from "styled-components";
import { Modal as ModalAnt } from "antd";
import { RightOutlined } from "@ant-design/icons";

export const Modal = styled(ModalAnt)`
  .ant-modal-header {
    border-radius: 0.3rem 0.3rem 0 0;
  }

  .ant-modal-content {
    border-radius: 0.3rem;
  }

  .ant-modal-body {
    padding: 1.5rem;
  }

  .ant-modal-title {
    font-weight: 500;
    font-size: 1.25rem;
    color: var(--gray-700);
  }
`;

export const OldValueContainer = styled.div`
  position: relative;
  padding-right: 30px;
`;

export const OldValueBadge = styled.span`
  display: inline-block;
  padding: 4px 8px;
  border-radius: 4px;
  background-color: #f5f5f5;
  color: #8c8c8c;
  max-width: calc(100% - 30px);
`;

export const ArrowIcon = styled(RightOutlined)`
  color: #1890ff;
  font-size: 16px;
  font-weight: bold;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
`;

export const NewValueBadge = styled.span`
  display: inline-block;
  padding: 4px 8px;
  border-radius: 4px;
  background-color: #f6ffed;
  color: #52c41a;
  font-weight: 500;
`;
